import React from "react";
import { useTranslation } from "react-i18next";
import InputCst from "@components/InputCst/InputCst";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData } from "../../../../types";

const YoutubeContent: React.FC<WizardStepProps<ActivityWizardData>> = ({
  data,
  setData,
  errors,
}) => {
  const { t } = useTranslation("wizard-activity");
  return (
    <InputCst
      id="activity-youtube"
      label={`${t("content.youtube.url")} *`}
      value={data.youtube_video}
      onChange={(e: any) => setData({ youtube_video: e.target.value })}
      error={!!errors.youtube_video}
      errorMessage={
        errors.youtube_video ? t(`errors.${errors.youtube_video}`) || "" : ""
      }
    />
  );
};

export default YoutubeContent;
